//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import * as styles from './ko.module.scss';
//------------------------------------------------------------------------------
// Helpers ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// Import locale json ----------------------------------------------------------
import { keyValidate } from '@helpers/validation';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------

class KoAdsConsent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      threshold: 100, // This calculates as an offset in PX for the header of our site
      table: [
        { col: 'ads_table_row1', value: ['ads_table_value1'] },
        {
          col: 'ads_table_row2',
          value: ['ads_table_value2-1'],
        },
        { col: 'ads_table_row3', value: ['ads_table_value3'] },
      ],
    };
  }

  componentDidMount() {
    if (window.location.hash === '#ads_consent') {
      window.scrollTo(
        0,
        document.getElementById('ads_consent_1').offsetTop -
          this.state.threshold,
      );
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div id="ads_consent_1">
        <p className={styles.leftAlign}>{t('ads_header')}</p>
        <p className={styles.marginTop}>{t('ads_IntroText')}</p>
        
        <div
          className={styles.tableContainer}
          role="table"
          aria-label="Destinations"
        >
          {this.state.table.map((value, key) => {
            return (
              <div className={styles.rowFlex} role="rowgroup" key={key + value}>
                <div className={styles.first} role="cell">
                  {keyValidate(value.col) && t(value.col)}
                </div>
                <div className={styles.second} role="cell">
                  {value.value.map((key) => {
                    return <li key={key}>{keyValidate(key) && t(key)}</li>;
                  })}
                </div>
              </div>
            );
          })}
        </div>
       
        <p className={styles.marginTop}>{t('ads_ending')}</p>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(KoAdsConsent);
